import { ARIA_CHECKED } from '../constants.esm.js';

const getAriaChecked = (isChecked, indeterminate) => {
    if (indeterminate) {
        return isChecked ? ARIA_CHECKED.MIXED : ARIA_CHECKED.FALSE;
    }
    return Boolean(isChecked);
};

export { getAriaChecked };
